module.exports = __webpack_public_path__ + "img/image2.34eb9f54.jpg";